import { Search } from "@mui/icons-material";
import { FC, ReactNode } from "react";
import { components, ControlProps } from "react-select";

import { onActivateKeyDown } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

import { ViewDropdownWrapperStyled } from "./dashboard-view.styled";

interface IViewDropdownProps {
  children?: ReactNode;
  readonly isOpen: boolean;
  readonly target: ReactNode;
  readonly onClose: () => void;
}

export const ViewDropdownWrapper: FC<IViewDropdownProps> = ({
  children,
  isOpen,
  target,
  onClose,
}) => (
  <ViewDropdownWrapperStyled>
    {target}
    {isOpen && <div data-e2e="view-dropdown-menu">{children}</div>}
    {isOpen && (
      <div
        className="dropdown_blanket"
        data-e2e="view-dropdown-blanket"
        onClick={onClose}
        onKeyDown={onActivateKeyDown(onClose)}
        role="button"
        tabIndex={0}
        aria-label="Close dropdown"
      />
    )}
  </ViewDropdownWrapperStyled>
);

export const ViewDropdownControl: FC<ControlProps> = ({
  children,
  ...props
}) => {
  return (
    <components.Control {...props}>
      <Search
        data-e2e="svg-view-dropdown-search"
        style={{ color: blueGreyMui._300 }}
      />
      {children}
    </components.Control>
  );
};
